<template>
	<HeroComponent>



		<template v-slot:hero-image>
			<div class="background-banner-reward-page w-100 h-100 d-flex flex-row justify-center"
				style="position: relative;">
				<v-img :src="AppConfigs.staticImages.COINBAG" class="h-100 w-100 hero-image-item1"></v-img>
				<RewardBannerItem2 class="h-100 hero-image-item2"></RewardBannerItem2>
			</div>
		</template>

		<template v-slot:hero-title>
			Get Rewards
		</template>

		<template v-slot:hero-subtitle>
			Convert tasks to cash.
		</template>




	</HeroComponent>
</template>



<script setup>

import { AppConfigs } from "@/app.configs";
import RewardBannerItem2 from '@/icons/RewardBannerItem2.vue';
import HeroComponent from '@/components/Common/Hero-Component.vue';


</script>



<style scoped lang="scss">

.hero-image-item1 {
	position: absolute;

	@media screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
		right: -25%;
	}

	@media screen and (max-width: vars.get-map-value(vars.$breakpoints, 'mobile')) {
		right: -25%;
	}

	@media screen and (min-width: 450px) and (max-width: 600px) {
		right: -25% !important;
	}
}

</style>
